import React from 'react'
import Stockdownloadfile from '../../components/stockreportcomponents/Stockdownloadfile'


function  Stockdownload({renderPageContent}) {
    return (
        <>
                        <Stockdownloadfile renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Stockdownload
